//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectionControlPanel from './selection-control-panel.vue';
import NestingControlPanel from './nesting-control-panel.vue';
import Multiselect from 'vue-multiselect'
import {kAnonUsername} from '../session.js'
import {upFromTaskView} from '../utils.js';
import HelpMenu from './help-menu.vue';
import AccountMenu from './account-menu.vue';

export default {
  data() {
    return {
      networkOnLine: window.navigator.onLine,
      appName: __ENV_NAME__ == 'prod'
        ? 'Organizer'
        : 'Organizer ' + __ENV_NAME__.toUpperCase(),
      showFiltering: false,
      selectedLabels: [],
      videoButtonClass: 'green',
      isMobile: (('ontouchstart' in window) ||
                  (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    SelectionControlPanel,
    NestingControlPanel,
    Multiselect,
    HelpMenu,
    AccountMenu,
  },
  computed: {
    title() {
      const layoutId = this.$route.params.layoutId
      if (layoutId && layoutId.startsWith('layout:')) {
        const name = this.$reactiveCache.docs[layoutId].name
        switch(name) {
          case "All lists":
            return this.$gettext("All lists");
          case "All periods":
            return this.$gettext("All periods");
          case "Items without a list":
            return this.$gettext("Items without a list");
          default:
            return name;
        } 
      }
      return this.appName;
    },
    offlineWarning() {
      return this.syncIconName == 'cloud_off'
        && this.$sessionState.loggedInAs != kAnonUsername
    },
    syncIconName() {
      if (!this.$sessionState || !this.$sessionState.syncStatus) {
        return 'hourglass_empty';
      }
      if (!this.networkOnLine) {
        return 'cloud_off';
      }
      return {
        'before init': 'cloud_queue',
        'offline': 'cloud_off',
        'push': 'cloud_upload',
        'fetch': 'cloud_download',
        'idle': 'cloud_done',
      }[this.$sessionState.syncStatus.activity];
    },
    syncIconTooltip() {
      if (!this.$sessionState || !this.$sessionState.syncStatus) {
        return this.$gettext('loading...');
      }
      if (!this.networkOnLine) {
        return this.$gettext('offline');
      }
      return {
        'before init': 'cloud_queue',
        'offline': this.$gettext('offline'),
        'push': this.$gettext('synchronizing...'),
        'fetch': this.$gettext('synchronizing...'),
        'idle': this.$gettext('in sync'),
      }[this.$sessionState.syncStatus.activity];
    },
    inTaskView() {
      return 'taskId' in this.$route.params;
    },
    anonymousSession() {
      if (this.$sessionState)
        return this.$sessionState.loggedInAs === kAnonUsername
      else
        return false
    },
    hasLabels() {
      return !!this.$root.reactiveLabels.length;
    },
  },
  methods: {
    switchView() {
      let link;
      if (!this.$settings || !this.$settings.multilist !== false) {
        link = '/calendar';
      } else if (this.$root.lastDashboard !== this.$route.path) {
        link = this.$root.lastDashboard;
      } else {
        link =
          this.$route.path.startsWith("/lists")
            ? '/calendar'
            : '/lists/layout:all-subtaskOf';
      }
      this.$router.push(link);
    },
    goUp() {
      upFromTaskView(this);
    },
    openSignup() {
      window.location.href = '/accounts/signup'
    },
    onOnline() {
      this.networkOnLine = true;
    },
    onOffline() {
      this.networkOnLine = false;
    },
  },
  mounted() {
    window.addEventListener('online', this.onOnline);
    window.addEventListener('offline', this.onOffline);
    this.$root.$on('show-onboarding', data => {
      this.videoButtonClass = 'green'
    });
    this.$root.$on('blink-video-button', data => {
      this.videoButtonClass = 'yellow'
    });
  },
  beforeDestroy() {
    window.removeEventListener('online', this.onOnline);
    window.removeEventListener('offline', this.onOffline);
  },
};
